export function LoadingState({label = 'Loading operational state'}: {label?: string}) {
  return <div className="state-panel">{label}…</div>
}

export function ErrorState({error}: {error: unknown}) {
  const message = error instanceof Error ? error.message : String(error)
  return (
    <div className="state-panel state-error">
      <strong>Data unavailable</strong>
      <span>{message}</span>
    </div>
  )
}
